export const MAP_ENTITY_COLOR = "#10b981"
export const MAP_ENTITY_COLOR_DISABLED = "#6f6d68"
export const MAP_ENTITY_COLOR_HOVER = "#ef4544"

export const DRIVE_SECTION_TYPE = "drive"
export const STOP_SECTION_TYPE = "stop"
